import { Module, Polyline } from './common'

/**
 * Base extraction module - converts points to polylines
 */
export abstract class Extraction extends Module {
  /**
   * Extract polylines from point cloud
   * @param points - Input point cloud as interleaved Float32Array [x,y,z,x,y,z,...]
   * @returns Array of extracted polylines
   */
  abstract run(points: Float32Array): Polyline[]

  /**
   * Get a human-readable name for this extraction method
   */
  abstract getName(): string
}
